import ProcessCompleted from '../../../../components/tuitionProcess/ProcessCompleted';

const Completed = () => {
  return <ProcessCompleted />;
};

export default Completed;
